module.exports = __webpack_public_path__ + "img/jrzq.10f7d752.png";